const m = window.require("@ember/test");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;